import { render, staticRenderFns } from "./accountflow-list.vue?vue&type=template&id=8af02df6&"
import script from "./accountflow-list.vue?vue&type=script&lang=js&"
export * from "./accountflow-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "accountflow-list.vue"
export default component.exports